import { createSelector } from "reselect"
import { iCurrentUser, ReduxState, tFeatures } from "../common/types"
import { startOfTheWeekSelector } from "../filters/selectors"

export const userSelector = (state: ReduxState): iCurrentUser => state.current_user

/** Selector for the current user's features object. */
export const selectCompanyFeatureToggles = createSelector(userSelector, (user): tFeatures => user.features)

export const startOfWeekIndexSelector = createSelector(userSelector, user => startOfTheWeekSelector(user))
